module.exports = __webpack_public_path__ + "img/vr-goggles.1a039f76.svg";